import { QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra-react';
import { PremiumStoreApiClient, PremiumCurrencyApiClient } from '@wix/premium-fed-sdk/@api-clients-react';
import { queryCurrencySettings, queryCurrencySettingsLegacy } from '../api-query-functions/queryCurrencySettings';
import { queryAvailableCycles } from '../api-query-functions/queryAvailableCycles.api-function';
import { queryCyclePricingDisplayProps } from '../api-query-functions/queryCyclePricingDisplayProps';
import { getPriceDisplayProps } from '../utils';
const NoopService = {
  baseUrl: ''
};
export const PricingApiConfig = {
  availableCycles: {
    name: 'availableCycles',
    service: NoopService,
    queryConfigType: QueryConfigTypes.STATIC_DATA,
    queryFn: queryAvailableCycles
  },
  pricingDisplayProps: {
    name: 'pricingDisplayProps',
    service: NoopService,
    queryConfigType: QueryConfigTypes.STATIC_DATA,
    queryFn: async _ref => {
      let {
        httpClient,
        request
      } = _ref;
      const {
        currencySettings
      } = await PremiumCurrencyApiClient.query.getCurrencySettings({
        httpClient,
        request: {}
      });
      const displayProps = getPriceDisplayProps({
        currencySettings: currencySettings,
        maximalMonthlyPrice: request.maximalMonthlyPrice,
        monthlyPrice: request.monthlyPrice,
        monthsPerCycle: request.monthsCount
      });
      return {
        displayProps
      };
    }
  },
  cyclePricingDisplayProps: {
    name: 'cyclePricingDisplayProps',
    service: NoopService,
    queryConfigType: QueryConfigTypes.STATIC_DATA,
    queryFn: queryCyclePricingDisplayProps
  },
  currencySettings: {
    name: 'currencySettings',
    service: NoopService,
    queryConfigType: QueryConfigTypes.STATIC_DATA,
    queryFn: queryCurrencySettings
  },
  currencySettingsLegacy: {
    name: 'currencySettingsLegacy',
    service: NoopService,
    queryConfigType: QueryConfigTypes.STATIC_DATA,
    queryFn: queryCurrencySettingsLegacy
  },
  hasSale: {
    name: 'hasSale',
    service: NoopService,
    queryConfigType: QueryConfigTypes.STATIC_DATA,
    queryFn: async _ref2 => {
      var _response$saleDetails;
      let {
        httpClient,
        request
      } = _ref2;
      const response = await PremiumStoreApiClient.query.getSale({
        httpClient,
        request: {
          productTypeId: request.productTypeId
        }
      });
      return {
        hasSale: ((_response$saleDetails = response.saleDetails) == null ? void 0 : _response$saleDetails.saleType) === 'Seasonal'
      };
    }
  }
};
//# sourceMappingURL=pricing-api.api-config.js.map